import { ModelBase } from '../abstract/model-base.model';
import { AgentTurn } from './agent-turn.model';
import { User } from '../user/user.model';
import { AgentUsage } from 'src/app/@core/services/ai/agent-relay.client';

/**
 * Une conversation de l'agent IA (#877).
 *
 * L'identifiant serveur est un UUID : on le stocke dans `sid` (identifiant
 * string de ModelBase) et non dans `id` (numérique).
 */
export class AgentSession extends ModelBase {

    static override CLASS_NAME: string = 'AgentSession';

    private _title!: string;
    private _agentCode!: string;
    private _turnCount!: number;
    private _usage!: AgentUsage | null;
    // Pas d'initialiseur (= []) : il s'exécuterait après super() et écraserait la
    // valeur désérialisée par hydrate(). On retombe sur [] via le getter.
    private _turns!: AgentTurn[];
    private _user!: User | null;
    // creationDate / updateDate sont hérités de ModelBase

    /** Remappe l'`id` (UUID) du serveur vers `sid` (identifiant string). */
    public override hydrate(data: any): void {
        if (!!data && data.id !== undefined && data.sid === undefined) {
            data = { ...data, sid: data.id };
            delete data.id;
        }
        super.hydrate(data);
    }

    public get title(): string {
        return this._title;
    }

    public set title(value: any) {
        this._setValue('_title', value, 'string');
    }

    public get agentCode(): string {
        return this._agentCode;
    }

    public set agentCode(value: any) {
        this._setValue('_agentCode', value, 'string');
    }

    public get turnCount(): number {
        return this._turnCount;
    }

    public set turnCount(value: any) {
        this._setValue('_turnCount', value, 'integer');
    }

    /** Cumul tokens + coût brut de la conversation (`cost` peut être `null`). */
    public get usage(): AgentUsage | null {
        return this._usage;
    }

    public set usage(value: any) {
        this._setValue('_usage', value, 'any');
    }

    public get turns(): AgentTurn[] {
        return this._turns ?? [];
    }

    public set turns(value: any) {
        this._setValue('_turns', value, 'AgentTurn');
    }

    /** Propriétaire de la session (supervision uniquement, §9.1) ; `null` sinon. */
    public get user(): User | null {
        return this._user;
    }

    public set user(value: any) {
        this._setValue('_user', value, 'User');
    }
}
